import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreService } from 'src/app/core/services/core.service';
import { environment } from 'src/environments/environment';
import { DragScrollComponent } from 'ngx-drag-scroll';

@Component({
  selector: 'bs-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  public twitterFeed$;
  public username;
  public tweets;
  public social;
  public showSideTweet = false;

  @ViewChild('instagramScroll', {read: DragScrollComponent}) ids: DragScrollComponent;

  constructor(
    private http: HttpClient,
    public coreService: CoreService,
  ) {
    this.social = environment.social;
    this.username = environment.twitterUsername;
    this.twitterFeed$ = this.coreService.fetchData(
      `https://api.digitalglacier.co/tools/feeds/twitter/${environment.twitterUsername}`
    );
    if (environment.client === 'britishshooting') {
      this.showSideTweet = true;
    }
   }

  ngOnInit() { }

  startSlideShow(ds, interval = 5000) {
    return setInterval(() => {
      if (ds) {
        if (ds.currIndex + 1 < ds.indexBound) {
          ds.moveTo(ds.currIndex + 1);
        } else {
          ds.moveTo(0);
        }
      }
    }, interval);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.startSlideShow(this.ids);
    }, 5000);
  }

}
